import { render, staticRenderFns } from "./AmountLabel.vue?vue&type=template&id=282739e8"
import script from "./AmountLabel.vue?vue&type=script&lang=js"
export * from "./AmountLabel.vue?vue&type=script&lang=js"
import style0 from "./AmountLabel.vue?vue&type=style&index=0&id=282739e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports